import {useNavigate, useSearchParams} from "react-router-dom";
import {useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {readQnaApi} from "../../../../api/support/qna";
import {ReadQnaApiProps} from "../../../../types/support/qna";
import moment from "moment";
import { getJwtPayloadValue } from "../../../../util/getJwtPayloadValue";
import { useUser } from "../../../../util/userContext/UserContext";

/**
 * QNA 목록 hook
 * @returns
 */
export default function useReadQna() {
    const [searchParams] = useSearchParams();
    const { user } = useUser();
    const navigate = useNavigate();

    const buildQuery = (searchParam: ReadQnaApiProps) => {
        return `?keywordType=${searchParam.keywordType}&pageNo=${searchParam.pageNo}&limit=${searchParam.limit}&startAt=${searchParam.startAt}&endAt=${searchParam.endAt}`;
    }

    const queryStringParam: ReadQnaApiProps = {
        keywordType: searchParams?.get("keywordType") || '0',
        pageNo: Number(searchParams?.get("pageNo")) || 1,
        limit: 10,
        startAt: searchParams?.get("startAt") || moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endAt: searchParams?.get("endAt") || moment().format('YYYY-MM-DD'),
        inOutFlag: getJwtPayloadValue('qnaWriteYn') ? '0' : '1',
        customerId: user?.userId
    }
    const [searchParam, setSearchParam] = useState(queryStringParam)

    const res = useQuery({
        queryKey: ["readQnaApi", queryStringParam],
        queryFn: async () => await readQnaApi(queryStringParam),
        // staleTime: 6000 * 10,
        select: (res) => res?.result
    });

    const search = () => {
        navigate(buildQuery(searchParam));
    }

    return {res, searchParam, setSearchParam, search}
}